import api from '@/api';

const resource = 'merenda/cota-alimentar';

export default {
  calcularCotaPrevista( anocardapio, identificadorescolalocalexterno, identificadortitulocardapio, identificadorcardapioescola, usaranoanterior ) {
    return api.get( `${resource}/calcular-previsto`, { params: {anocardapio, identificadorescolalocalexterno, identificadortitulocardapio, identificadorcardapioescola, usaranoanterior} });
  },

  carregarCotaEfetiva( anocardapio, identificadorescolalocalexterno, identificadorcardapioescola ) {
    return api.get( `${resource}`, { params: {anocardapio, identificadorescolalocalexterno, identificadorcardapioescola} });
  },

  salvarCota(identificadorcardapioescola, quantidadeAlunosDoCardapio, cota  ) {
    return api.post( `${resource}`, {identificadorcardapioescola, quantidadeAlunosDoCardapio, cota});
  },

  inserirSaidas( identificadorcardapioescola, cdturma, saidas ) {
    return api.post( `${resource}`, { identificadorcardapioescola, cdturma, saidas } );
  },
};
